import React from 'react'
import styles from './remove-from-group.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import GroupsSelect from '../../../../groups-select/groups-select.container'
import { Formik } from 'formik'

const RemoveFromGroup = ({
  classes,
  opened,
  requestClose = () => null,
  onSubmit,
  title,
  includeGroups,
  noGroups
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>{title}</ModalHeader>
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        group: ''
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          isValid
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <GroupsSelect
                only={includeGroups}
                selectOption="Select a group"
                whenNoGroupsAvailable={
                  <span>This pupil is not a part of any group</span>
                }
                formSelectProps={{
                  value: values.group,
                  name: 'group',
                  onChange: handleChange,
                  onBlur: handleBlur
                }}
              />
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid} tall type="submit">
                Remove from group
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(RemoveFromGroup)
